var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 559,
    viewBox: "0 0 630 559",
    width: 630,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m630 273.5c0 151.05-122.275 273.5-273.108 273.5-150.834 0 45.975-122.45 45.975-273.5s-196.809-273.5-45.975-273.5c150.833 0 273.108 122.45 273.108 273.5z",
    fill: "#f6faff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m266.813 478.874c-144.596-43.787-226.3175-196.501-182.531-341.096 43.787-144.59588 103.872 79.569 248.467 123.356 144.596 43.786 318.947-109.387 275.16 35.209-43.786 144.596-196.5 226.318-341.096 182.531z",
    fill: "#ebf4ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m90.7228 471.057c50.1052 0 90.7232-2.729 90.7232-6.097 0-3.367-40.618-6.097-90.7232-6.097-50.1048 0-90.7228 2.73-90.7228 6.097 0 3.368 40.618 6.097 90.7228 6.097z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m90.7228 471.057c50.1052 0 90.7232-2.729 90.7232-6.097 0-3.367-40.618-6.097-90.7232-6.097-50.1048 0-90.7228 2.73-90.7228 6.097 0 3.368 40.618 6.097 90.7228 6.097z",
    fill: "#5468ff",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m113.969 158.377c7.428-6.926 19.007-6.845 26.981-.553 13.083 10.317 37.468 29.413 45.345 34.697 10.943 7.317 59.616 35.161 59.616 35.161l-5.313 11.568s-60.853-21.462-69.511-27.421c-8.657-5.959-58.363-31.624-61.024-43.087-.96-4.04.895-7.552 3.906-10.365z",
    fill: "#5468ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m230.607 223.918c.992.195 5.215 1.682 5.581-.106.432-2.114-3.954-3.138-5.264-2.975-1.88.235-3.767-.252-6.143.357-1.872.48-3.637.951-5.525 1.407-1.033.244-1.839 1.065-2.831 1.471-.814.325-2.376 1.358-3.711 1.35-.491-.04-.978-.122-1.456-.244-.073.227-.073.463-.155.683-.996 2.606-2.132 5.157-3.401 7.641 1.572.164 3.156.164 4.728 0 .974-.133 1.967.011 2.864.415.878.309 1.765.642 2.652.959.702.328 1.428.6 2.173.813.675.13 1.904.098 2.034-.748-.003-.408-.097-.811-.274-1.179-.178-.368-.434-.693-.751-.951-.944-.812-4.142-.609-3.54-2.438.395-.816.948-1.546 1.627-2.147.628-.627 1.426-1.056 2.295-1.235 1.744-.592 3.606-.757 5.427-.48 1.147.187 2.189.366 3.255-.301.813-.512 1.171-1.065.122-1.764-.361-.243-.746-.45-1.148-.618.482-.021.965.009 1.441.09z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m330.287 349.187c139.602 0 252.771-8.718 252.771-19.471s-113.169-19.47-252.771-19.47c-139.601 0-252.7704 8.717-252.7704 19.47s113.1694 19.471 252.7704 19.471z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m330.287 349.187c139.602 0 252.771-8.718 252.771-19.471s-113.169-19.47-252.771-19.47c-139.601 0-252.7704 8.717-252.7704 19.47s113.1694 19.471 252.7704 19.471z",
    fill: "#5468ff",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m458.089 71.4147-14.329-4.2274c-.524-.1635-1.076-.2208-1.623-.1686s-1.078.2127-1.562.4724c-.484.2596-.912.6131-1.257 1.0397-.346.4266-.603.9178-.757 1.4449l-1.839 6.2192c-5.564-.327-11.144.2635-16.517 1.7478l-3.1-5.6907c-.529-.9573-1.416-1.666-2.467-1.9708s-2.18-.1808-3.139.3449l-13.124 7.1378c-.958.5282-1.668 1.4145-1.973 2.4645s-.181 2.1781.345 3.1368l3.1 5.6907c-4.16 3.6886-7.684 8.0364-10.431 12.8691l-6.184-1.837c-1.05-.3104-2.182-.1909-3.144.332-.963.523-1.679 1.406-1.99 2.456l-4.231 14.316c-.153.52-.203 1.064-.146 1.603.057.538.22 1.06.479 1.536.26.476.61.896 1.032 1.236.421.34.906.594 1.426.747l6.225 1.837c-.328 5.56.263 11.136 1.749 16.503l-5.696 3.098c-.958.528-1.667 1.414-1.972 2.464s-.181 2.178.345 3.137l7.136 13.113c.529.957 1.416 1.666 2.466 1.971 1.051.305 2.18.181 3.14-.345l5.696-3.097c3.699 4.163 8.062 7.687 12.912 10.43l-1.839 6.219c-.31 1.05-.19 2.18.333 3.142s1.408 1.677 2.458 1.988l14.329 4.227c.52.154 1.065.203 1.604.146s1.061-.22 1.537-.479c.476-.258.897-.609 1.237-1.03.341-.421.595-.906.748-1.425l1.839-6.219c5.561.327 11.139-.263 16.509-1.748l3.1 5.691c.529.957 1.416 1.666 2.466 1.97 1.051.305 2.18.181 3.14-.345l13.124-7.137c.958-.529 1.668-1.415 1.973-2.465s.181-2.178-.345-3.137l-3.1-5.69c4.166-3.698 7.693-8.057 10.439-12.902l6.224 1.837c1.051.31 2.182.191 3.145-.332s1.678-1.406 1.989-2.456l4.231-14.316c.311-1.05.191-2.181-.332-3.143-.523-.961-1.408-1.676-2.458-1.987l-6.225-1.837c.328-5.557-.263-11.13-1.749-16.495l5.695-3.098c.958-.528 1.668-1.414 1.973-2.464s.181-2.178-.345-3.137l-7.136-13.1131c-.529-.9573-1.416-1.666-2.467-1.9708s-2.18-.1808-3.139.3449l-5.696 3.0973c-3.7-4.1633-8.063-7.6875-12.913-10.4302l1.839-6.2192c.302-1.0413.182-2.1594-.334-3.1131-.516-.9536-1.387-1.6663-2.424-1.9841zm-18.372 35.6803c3.96 1.17 7.484 3.486 10.126 6.656 2.643 3.17 4.286 7.052 4.72 11.155.435 4.103-.358 8.242-2.278 11.895-1.92 3.652-4.881 6.654-8.509 8.625-3.627 1.972-7.758 2.824-11.87 2.45-4.112-.375-8.021-1.959-11.232-4.553s-5.58-6.081-6.808-10.02c-1.228-3.94-1.258-8.154-.089-12.111.777-2.627 2.064-5.076 3.788-7.206 1.724-2.131 3.851-3.901 6.26-5.21 2.408-1.309 5.052-2.131 7.778-2.42 2.727-.288 5.484-.037 8.114.739z",
    fill: "#5468ff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m442.345 98.2016c-5.722-1.6915-11.818-1.6487-17.517.1227-5.698 1.7717-10.742 5.1917-14.494 9.8287s-6.043 10.282-6.583 16.22.695 11.903 3.549 17.14c2.854 5.236 7.199 9.509 12.484 12.278 5.286 2.768 11.275 3.908 17.209 3.275s11.546-3.011 16.127-6.833c4.581-3.821 7.925-8.915 9.608-14.635 2.255-7.66 1.375-15.9-2.447-22.912-3.821-7.012-10.272-12.222-17.936-14.4844zm-2.628 8.8934c3.96 1.169 7.485 3.485 10.127 6.656 2.643 3.17 4.285 7.052 4.72 11.155.434 4.102-.358 8.242-2.278 11.895-1.92 3.652-4.881 6.654-8.509 8.625-3.627 1.971-7.758 2.824-11.87 2.449-4.113-.374-8.021-1.958-11.232-4.552-3.212-2.594-5.581-6.081-6.808-10.02-1.228-3.94-1.259-8.154-.089-12.111.777-2.627 2.064-5.076 3.788-7.207 1.724-2.13 3.851-3.9 6.259-5.209 2.409-1.309 5.052-2.131 7.779-2.42 2.727-.288 5.484-.037 8.113.739z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m339.344 74.333-8.405-2.4388c-.615-.1775-1.275-.1066-1.838.1975s-.984.8171-1.172 1.4284l-1.074 3.6502c-3.268-.1927-6.544.1534-9.699 1.0243l-1.823-3.3413c-.309-.5532-.822-.9644-1.429-1.1464-.608-.1821-1.262-.1208-1.825.1709l-7.771 4.1786c-.552.3104-.962.8233-1.143 1.4301-.18.6069-.118 1.2602.175 1.8217l1.823 3.3413c-2.446 2.1718-4.516 4.7317-6.127 7.5768l-3.654-1.0813c-.615-.1775-1.275-.1065-1.838.1976s-.984.8171-1.172 1.4284l-2.466 8.455c-.177.614-.106 1.274.198 1.836.305.563.818.984 1.43 1.172l3.653 1.081c-.185 3.257.167 6.523 1.042 9.666l-3.312 1.837c-.552.311-.962.824-1.143 1.43-.18.607-.118 1.261.175 1.822l4.19 7.699c.311.552.824.961 1.431 1.142.608.18 1.262.118 1.824-.175l3.344-1.821c2.173 2.444 4.735 4.513 7.583 6.122l-1.082 3.65c-.178.614-.107 1.274.198 1.837.304.562.817.983 1.429 1.171l8.413 2.48c.615.177 1.276.106 1.839-.198s.984-.817 1.172-1.428l1.082-3.651c3.265.193 6.539-.153 9.691-1.024l1.822 3.341c.311.552.824.962 1.432 1.142.607.181 1.261.118 1.823-.174l7.705-4.187c.553-.31.962-.823 1.143-1.43s.118-1.26-.174-1.822l-1.823-3.341c2.445-2.172 4.515-4.732 6.127-7.577l3.653 1.081c.616.18 1.278.111 1.843-.194.565-.304.988-.818 1.176-1.432l2.482-8.406c.177-.614.106-1.274-.198-1.836-.305-.563-.818-.983-1.43-1.171l-3.653-1.082c.193-3.262-.154-6.533-1.025-9.6821l3.344-1.821c.552-.3104.962-.8233 1.143-1.4301.18-.6069.118-1.2602-.175-1.8217l-4.19-7.6988c-.311-.5518-.824-.9612-1.432-1.1418-.607-.1805-1.261-.118-1.823.1744l-3.344 1.821c-2.173-2.4437-4.735-4.5121-7.583-6.1216l1.082-3.6501c.099-.3101.134-.6367.105-.9607-.03-.324-.124-.6389-.277-.926s-.362-.5407-.615-.7458c-.253-.2052-.544-.3577-.857-.4487zm-10.764 20.9663c2.326.6835 4.398 2.0409 5.952 3.9006 1.555 1.8601 2.522 4.1381 2.781 6.5471.258 2.409-.204 4.841-1.329 6.988-1.125 2.146-2.861 3.912-4.99 5.072-2.128 1.161-4.554 1.665-6.969 1.448-2.416-.216-4.712-1.143-6.6-2.664s-3.282-3.567-4.007-5.879c-.724-2.313-.746-4.788-.062-7.112.454-1.544 1.208-2.984 2.219-4.2363 1.01-1.2527 2.258-2.2942 3.672-3.0649 1.414-.7708 2.966-1.2558 4.567-1.4273s3.221-.0261 4.766.4278z",
    fill: "#5468ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m330.125 90.072c-3.359-.9921-6.938-.9663-10.282.0743-3.345 1.0406-6.305 3.0491-8.507 5.7713-2.202 2.7223-3.546 6.0364-3.862 9.5214-.317 3.486.409 6.987 2.085 10.061 1.676 3.073 4.227 5.581 7.33 7.205 3.102 1.625 6.618 2.293 10.101 1.921s6.778-1.769 9.466-4.012c2.689-2.244 4.651-5.234 5.638-8.592 1.322-4.497.804-9.333-1.44-13.4488-2.244-4.1153-6.031-7.1728-10.529-8.5012zm-1.546 5.2192c2.327.683 4.398 2.0398 5.953 3.899 1.555 1.8588 2.523 4.1368 2.782 6.5458s-.202 4.841-1.326 6.987c-1.124 2.147-2.859 3.913-4.987 5.074-2.129 1.162-4.553 1.667-6.969 1.451-2.415-.215-4.712-1.141-6.6-2.661-1.889-1.519-3.284-3.564-4.01-5.876-.725-2.312-.748-4.786-.066-7.111.454-1.544 1.208-2.984 2.218-4.2363 1.011-1.2526 2.259-2.2941 3.673-3.0649 1.413-.7708 2.965-1.2558 4.566-1.4273 1.602-.1715 3.221-.0261 4.766.4278z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m442.345 98.2016c-5.722-1.6915-11.818-1.6487-17.517.1227-5.698 1.7717-10.742 5.1917-14.494 9.8287s-6.043 10.282-6.583 16.22.695 11.903 3.549 17.14c2.854 5.236 7.199 9.509 12.484 12.278 5.286 2.768 11.275 3.908 17.209 3.275s11.546-3.011 16.127-6.833c4.581-3.821 7.925-8.915 9.608-14.635 2.255-7.66 1.375-15.9-2.447-22.912-3.821-7.012-10.272-12.222-17.936-14.4844zm-2.628 8.8934c3.96 1.169 7.485 3.485 10.127 6.656 2.643 3.17 4.285 7.052 4.72 11.155.434 4.102-.358 8.242-2.278 11.895-1.92 3.652-4.881 6.654-8.509 8.625-3.627 1.971-7.758 2.824-11.87 2.449-4.113-.374-8.021-1.958-11.232-4.552-3.212-2.594-5.581-6.081-6.808-10.02-1.228-3.94-1.259-8.154-.089-12.111.777-2.627 2.064-5.076 3.788-7.207 1.724-2.13 3.851-3.9 6.259-5.209 2.409-1.309 5.052-2.131 7.779-2.42 2.727-.288 5.484-.037 8.113.739z",
    fill: "#5468ff",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m330.125 90.072c-3.359-.9921-6.938-.9663-10.282.0743-3.345 1.0406-6.305 3.0491-8.507 5.7713-2.202 2.7223-3.546 6.0364-3.862 9.5214-.317 3.486.409 6.987 2.085 10.061 1.676 3.073 4.227 5.581 7.33 7.205 3.102 1.625 6.618 2.293 10.101 1.921s6.778-1.769 9.466-4.012c2.689-2.244 4.651-5.234 5.638-8.592 1.322-4.497.804-9.333-1.44-13.4488-2.244-4.1153-6.031-7.1728-10.529-8.5012zm-1.546 5.2192c2.327.683 4.398 2.0398 5.953 3.899 1.555 1.8588 2.523 4.1368 2.782 6.5458s-.202 4.841-1.326 6.987c-1.124 2.147-2.859 3.913-4.987 5.074-2.129 1.162-4.553 1.667-6.969 1.451-2.415-.215-4.712-1.141-6.6-2.661-1.889-1.519-3.284-3.564-4.01-5.876-.725-2.312-.748-4.786-.066-7.111.454-1.544 1.208-2.984 2.218-4.2363 1.011-1.2526 2.259-2.2941 3.673-3.0649 1.413-.7708 2.965-1.2558 4.566-1.4273 1.602-.1715 3.221-.0261 4.766.4278z",
    fill: "#5468ff",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m427.984 144.922v126.659h-226.099v-126.659c0-2.468.981-4.836 2.728-6.582 1.748-1.745 4.117-2.726 6.588-2.726h207.483c2.468.004 4.833.987 6.577 2.732s2.723 4.11 2.723 6.576z",
    fill: "#5468ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m427.984 144.922v126.659h-226.099v-126.659c0-2.468.981-4.836 2.728-6.582 1.748-1.745 4.117-2.726 6.588-2.726h207.483c2.468.004 4.833.987 6.577 2.732s2.723 4.11 2.723 6.576z",
    fill: "#000d44",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m418.082 146.256h-206.295v125.334h206.295z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m418.082 146.256h-206.295v125.334h206.295z",
    fill: "#5468ff",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m344.502 316.465h-59.145l6.493-21.771h46.826z",
    fill: "#5468ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m344.502 316.465h-59.145l6.493-21.771h46.826z",
    fill: "#000d44",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m427.984 271.582v13.82c0 1.222-.241 2.433-.71 3.562-.468 1.129-1.154 2.156-2.019 3.02s-1.892 1.55-3.023 2.018c-1.13.467-2.341.708-3.565.708h-207.482c-2.471 0-4.841-.98-6.588-2.726s-2.729-4.113-2.729-6.582v-13.82z",
    fill: "#5468ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m291.851 294.694-2.108 7.048h50.821l-1.887-7.048z",
    fill: "#5468ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m352.525 327.351h-75.19c-1.446 0-2.832-.574-3.854-1.596-1.023-1.021-1.597-2.407-1.597-3.851 0-1.445.574-2.83 1.597-3.852 1.022-1.021 2.408-1.595 3.854-1.595h75.199c1.445 0 2.832.574 3.854 1.595 1.023 1.022 1.597 2.407 1.597 3.852 0 .716-.141 1.425-.416 2.086-.274.662-.676 1.262-1.184 1.768-.507.506-1.109.907-1.771 1.18-.662.274-1.372.414-2.089.413z",
    fill: "#5468ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m356.122 235.299c-1.572-1.555-3.548-2.641-5.704-3.135-2.157-.494-4.408-.377-6.501.338l-49.715-49.428c.698-2.104.792-4.362.272-6.517-.521-2.156-1.635-4.122-3.217-5.677-2.653-2.61-5.379-2.634-9.919-2.992-.226-.021-.453.028-.65.141s-.354.285-.45.491c-.095.206-.124.436-.083.659.041.224.15.429.313.587l4.532 4.463c.102.102.183.223.238.357.055.133.084.276.084.42s-.029.287-.084.42-.136.254-.238.356l-5.696 5.78c-.102.102-.223.183-.356.239-.134.055-.277.083-.421.083s-.287-.028-.421-.083c-.133-.056-.254-.137-.356-.239l-5.248-5.17c-.162-.16-.37-.266-.595-.303s-.456-.003-.66.097c-.205.1-.374.261-.482.461-.109.2-.153.429-.126.655.472 4.521 1.025 7.602 3.93 10.471 1.597 1.569 3.605 2.656 5.793 3.135 2.188.478 4.467.33 6.574-.427l49.633 49.371c-.743 2.121-.87 4.409-.364 6.599.505 2.19 1.622 4.192 3.22 5.774 2.913 2.87 5.997 3.382 10.529 3.788.228.026.457-.021.657-.132.2-.112.36-.283.458-.49s.128-.439.087-.664c-.041-.226-.151-.432-.315-.592l-5.248-5.17c-.102-.102-.183-.223-.239-.356-.055-.133-.083-.276-.083-.42 0-.145.028-.287.083-.421.056-.133.137-.254.239-.356l5.695-5.78c.102-.102.224-.183.357-.238s.276-.084.42-.084c.145 0 .288.029.421.084s.254.136.356.238l4.533 4.463c.161.159.367.264.59.301s.452.004.656-.094c.204-.097.372-.256.483-.453.11-.197.157-.423.134-.648-.415-4.585-.464-7.317-3.116-9.902z",
    fill: "#5468ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m335.951 203.073c-6.509 2.846-15.549 6.691-19.698 16.878l-10.098-10.114c10.212-4.121 14.085-13.121 16.941-19.641s21.155-19.633 24.759-21.56c.207-.109.422-.201.643-.276 3.434-1.211 7.168 2.211 7.168 2.211s3.418 3.74 2.197 7.171c-.074.221-.167.436-.276.642-1.937 3.585-15.102 21.852-21.636 24.689z",
    fill: "#5468ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m335.951 203.073c-6.509 2.846-15.549 6.691-19.698 16.878l-10.098-10.114c10.212-4.121 14.085-13.121 16.941-19.641s21.155-19.633 24.759-21.56c.207-.109.422-.201.643-.276 3.434-1.211 7.168 2.211 7.168 2.211s3.418 3.74 2.197 7.171c-.074.221-.167.436-.276.642-1.937 3.585-15.102 21.852-21.636 24.689z",
    fill: "#000d44",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m357.863 177.75c-.946-.414-1.989-.558-3.012-.414-1.023.143-1.986.568-2.781 1.227-2.848 2.292-4.598.179-4.598.179s-2.107-1.748.188-4.594c.659-.794 1.084-1.756 1.228-2.779.143-1.022 0-2.064-.415-3.009 3.434-1.211 7.169 2.211 7.169 2.211s3.441 3.756 2.221 7.179z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m357.863 177.75c-.946-.414-1.989-.558-3.012-.414-1.023.143-1.986.568-2.781 1.227-2.848 2.292-4.598.179-4.598.179s-2.107-1.748.188-4.594c.659-.794 1.084-1.756 1.228-2.779.143-1.022 0-2.064-.415-3.009 3.434-1.211 7.169 2.211 7.169 2.211s3.441 3.756 2.221 7.179z",
    fill: "#5468ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m316.252 219.959-5.573 4.593c-.527.436-1.198.659-1.882.626-.683-.033-1.33-.32-1.812-.805l-5.281-5.292c-.484-.483-.77-1.13-.802-1.813-.031-.683.194-1.353.631-1.878l4.614-5.553z",
    fill: "#5468ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m330.036 201.854c-.903.642-4.15-1.626-4.15-1.626s-2.221-3.252-1.586-4.146c6.013-8.422 16.134-17.511 18.112-17.885 1.977-.374 4.206 1.414 4.206 1.414s1.831 2.212 1.424 4.187c-.407 1.976-9.56 12.073-18.006 18.056z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m330.036 201.854c-.903.642-4.15-1.626-4.15-1.626s-2.221-3.252-1.586-4.146c6.013-8.422 16.134-17.511 18.112-17.885 1.977-.374 4.206 1.414 4.206 1.414s1.831 2.212 1.424 4.187c-.407 1.976-9.56 12.073-18.006 18.056z",
    fill: "#5468ff",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m338.362 191.687c4.855-4.839 7.926-9.627 6.86-10.695-1.067-1.068-5.867 1.988-10.722 6.827-4.854 4.839-7.926 9.628-6.859 10.696 1.066 1.068 5.866-1.989 10.721-6.828z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m338.362 191.687c4.855-4.839 7.926-9.627 6.86-10.695-1.067-1.068-5.867 1.988-10.722 6.827-4.854 4.839-7.926 9.628-6.859 10.696 1.066 1.068 5.866-1.989 10.721-6.828z",
    fill: "#5468ff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m302.705 220.081-22.758 22.649-2.172 1.325-1.302 1.455 3.873 3.878 1.456-1.293 1.383-2.122 22.742-22.665z",
    fill: "#5468ff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m302.705 220.081-22.758 22.649-2.172 1.325-1.302 1.455 3.873 3.878 1.456-1.293 1.383-2.122 22.742-22.665z",
    fill: "#000d44",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m276.497 252.639-3.238-3.243 3.214-3.886 3.873 3.878z",
    fill: "#5468ff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m351.082 177.636c.684-.682.685-1.789.003-2.472-.683-.684-1.79-.685-2.474-.003s-.686 1.788-.003 2.472c.682.683 1.79.684 2.474.003z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m512.49 260.103h-113.733v81.995h113.733z",
    fill: "#5468ff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m512.49 260.103h-113.733v81.995h113.733z",
    fill: "#000d44",
    opacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m458.358 275.711h-55.044v2.927h55.044z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m455.388 274.216h-49.113v5.926h49.113z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m454.175 275.923h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m446.763 275.923h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m439.359 275.923h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m431.947 275.923h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m424.534 275.923h-2.222v2.512h2.222z",
    fill: "#5468ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m417.122 275.923h-2.222v2.512h2.222z",
    fill: "#5468ff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m409.71 275.923h-2.222v2.512h2.222z",
    fill: "#5468ff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m458.358 266.492h-55.044v2.927h55.044z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m455.388 264.997h-49.113v5.926h49.113z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m454.175 266.704h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m446.763 266.704h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m439.359 266.704h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m431.947 266.704h-2.221v2.512h2.221z",
    fill: "#5468ff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m424.534 266.704h-2.222v2.512h2.222z",
    fill: "#5468ff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m417.122 266.704h-2.222v2.512h2.222z",
    fill: "#5468ff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m409.71 266.704h-2.222v2.512h2.222z",
    fill: "#5468ff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m485.054 264.029h-19.715v6.797h19.715z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m468.439 266.273h-1.798v2.292h1.798z",
    fill: "#5468ff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m470.993 266.273h-1.798v2.292h1.798z",
    fill: "#5468ff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m473.548 266.273h-1.798v2.292h1.798z",
    fill: "#5468ff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m476.103 266.273h-1.798v2.292h1.798z",
    fill: "#5468ff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m478.659 266.273h-1.799v2.292h1.799z",
    fill: "#5468ff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m481.213 266.273h-1.798v2.292h1.798z",
    fill: "#5468ff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m483.76 266.273h-1.798v2.292h1.798z",
    fill: "#5468ff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m485.054 274.281h-19.715v6.796h19.715z",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m468.439 276.524h-1.798v2.293h1.798z",
    fill: "#5468ff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m470.993 276.524h-1.798v2.293h1.798z",
    fill: "#5468ff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m473.548 276.524h-1.798v2.293h1.798z",
    fill: "#5468ff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m476.103 276.524h-1.798v2.293h1.798z",
    fill: "#5468ff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m478.659 276.524h-1.799v2.293h1.799z",
    fill: "#5468ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m481.213 276.524h-1.798v2.293h1.798z",
    fill: "#5468ff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m483.76 276.524h-1.798v2.293h1.798z",
    fill: "#5468ff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m454.142 291.531h-41.285v41.25h41.285z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5468ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m419.579 297.149h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 297.149h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 297.149h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 297.149h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 297.149h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 297.149h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 297.149h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 297.149h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 297.149h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 297.149h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 297.149h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 299.344h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 299.344h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 299.344h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 299.344h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 299.344h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 299.344h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 299.344h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 299.344h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 299.344h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 299.344h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 299.344h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 301.539h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 301.539h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 301.539h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 301.539h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 301.539h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 301.539h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 301.539h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 301.539h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 301.539h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 301.539h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 301.539h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 303.734h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 303.734h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 303.734h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 303.734h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 303.734h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 303.734h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 303.734h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 303.734h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 303.734h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 303.734h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 303.734h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 305.929h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 305.929h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 305.929h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 305.929h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 305.929h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 305.929h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 305.929h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 305.929h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 305.929h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 305.929h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 305.929h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 308.124h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 308.124h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 308.124h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 308.124h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 308.124h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 308.124h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 308.124h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 308.124h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 308.124h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 308.124h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 308.124h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 310.319h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 310.319h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 310.319h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 310.319h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 310.319h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 310.319h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 310.319h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 310.319h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 310.319h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 310.319h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 310.319h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 312.522h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 312.522h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 312.522h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 312.522h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 312.522h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 312.522h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 312.522h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 312.522h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 312.522h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 312.522h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 312.522h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 314.717h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 314.717h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 314.717h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 314.717h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 314.717h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 314.717h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 314.717h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 314.717h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 314.717h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 314.717h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 314.717h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 316.912h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 316.912h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 316.912h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 316.912h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 316.912h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 316.912h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 316.912h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 316.912h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 316.912h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 316.912h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 316.912h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 319.107h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 319.107h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 319.107h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 319.107h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 319.107h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 319.107h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 319.107h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 319.107h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 319.107h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 319.107h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 319.107h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 321.302h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 321.302h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 321.302h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 321.302h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 321.302h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 321.302h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 321.302h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 321.302h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 321.302h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 321.302h-1.465v1.464h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 321.302h-1.464v1.464h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 323.497h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 323.497h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 323.497h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 323.497h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 323.497h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 323.497h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 323.497h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 323.497h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 323.497h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 323.497h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 323.497h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.579 325.692h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.508 325.692h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.437 325.692h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.366 325.692h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.303 325.692h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.233 325.692h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.162 325.692h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.092 325.692h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.02 325.692h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.958 325.692h-1.465v1.463h1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.886 325.692h-1.464v1.463h1.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.091 305.563h-13.19v13.178h13.19z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m414.412 297.946h-6.624l-2.717-5.479h-6.314v-1.041h6.957l2.717 5.471h5.981z",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m414.412 308.344h-6.624l-2.717-5.48h-6.314v-1.04h6.957l2.717 5.479h5.981z",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m414.412 318.741h-6.624l-2.717-5.471h-6.314v-1.041h6.957l2.717 5.472h5.981z",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m414.412 329.147h-6.624l-2.717-5.479h-6.314v-1.041h6.957l2.717 5.48h5.981z",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m462.174 302.1h6.623v-1.041h-5.98l-2.718-5.479h-6.956v1.041h6.314z",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m462.174 312.498h6.623v-1.033h-5.98l-2.718-5.479h-6.956v1.041h6.314z",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m462.174 322.904h6.623v-1.041h-5.98l-2.718-5.479h-6.956v1.04h6.314z",
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m462.174 333.302h6.623v-1.041h-5.98l-2.718-5.471h-6.956v1.04h6.314z",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m469.456 296.182h-2.197v41.859h2.197z",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m478.781 296.182h-2.197v41.859h2.197z",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m477.682 299.815h-9.015v34.6h9.015z",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m476.892 329.399h-7.445v2.236h7.445z",
    fill: "#5468ff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m476.892 324.936h-7.445v2.228h7.445z",
    fill: "#5468ff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m476.892 320.465h-7.445v2.235h7.445z",
    fill: "#5468ff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m476.892 316.002h-7.445v2.227h7.445z",
    fill: "#5468ff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m476.892 311.539h-7.445v2.235h7.445z",
    fill: "#5468ff"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m476.892 307.067h-7.445v2.236h7.445z",
    fill: "#5468ff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m476.892 302.604h-7.445v2.227h7.445z",
    fill: "#5468ff"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m485.371 302.1h-6.623v-1.041h5.98l2.718-5.479h6.957v1.041h-6.314z",
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m485.371 312.498h-6.623v-1.033h5.98l2.718-5.479h6.957v1.041h-6.314z",
    fill: "#fff"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m485.371 322.904h-6.623v-1.041h5.98l2.718-5.479h6.957v1.04h-6.314z",
    fill: "#fff"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m485.371 333.302h-6.623v-1.041h5.98l2.718-5.471h6.957v1.04h-6.314z",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m277.09 327.017h-106.89v12.959h106.89z",
    fill: "#5468ff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m277.09 175.839h-106.89v151.178h106.89z",
    fill: "#5468ff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m277.09 175.839h-106.89v151.178h106.89z",
    fill: "#000d44",
    opacity: 0.3
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m269.816 183.107h-92.334v136.634h92.334z",
    fill: "#000d44",
    opacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m217.085 197.35h-28.039v3.764h28.039z",
    fill: "#fff"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m231.226 197.35h-7.307v3.764h7.307z",
    fill: "#fff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m244.74 197.35h-7.306v3.764h7.306z",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m258.246 197.35h-7.307v3.764h7.307z",
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m185.4 197.35h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m265.651 197.35h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m217.085 259.517h-28.039v3.764h28.039z",
    fill: "#fff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m231.226 259.517h-7.307v3.764h7.307z",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m244.74 259.517h-7.306v3.764h7.306z",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m258.246 259.517h-7.307v3.764h7.307z",
    fill: "#fff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m185.4 259.517h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m265.651 259.517h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m203.065 213.301h-14.019v3.764h14.019z",
    fill: "#fff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m231.226 213.301h-23.662v3.764h23.662z",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m244.74 213.301h-7.306v3.764h7.306z",
    fill: "#fff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m258.246 213.301h-7.307v3.764h7.307z",
    fill: "#fff"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m185.4 213.301h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m265.651 213.301h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m203.065 303.352h-14.019v3.764h14.019z",
    fill: "#fff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m231.226 303.352h-23.662v3.764h23.662z",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m244.74 303.352h-7.306v3.764h7.306z",
    fill: "#fff"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m258.246 303.352h-7.307v3.764h7.307z",
    fill: "#fff"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m185.4 303.352h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m265.651 303.352h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m203.065 273.687h-14.019v3.764h14.019z",
    fill: "#fff"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m231.226 273.687h-23.662v3.764h23.662z",
    fill: "#fff"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m244.74 273.687h-7.306v3.764h7.306z",
    fill: "#fff"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m258.246 273.687h-7.307v3.764h7.307z",
    fill: "#fff"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m185.4 273.687h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m265.651 273.687h-3.767v3.764h3.767z",
    fill: "#fff"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m230.208 247.062h28.039v-3.764h-28.039z",
    fill: "#fff"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m216.066 247.062h7.307v-3.764h-7.307z",
    fill: "#fff"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m202.552 247.062h7.306v-3.764h-7.306z",
    fill: "#fff"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m189.046 247.062h7.307v-3.764h-7.307z",
    fill: "#fff"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m261.892 247.062h3.767v-3.764h-3.767z",
    fill: "#fff"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m181.641 247.062h3.767v-3.764h-3.767z",
    fill: "#fff"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m244.228 231.113h14.019v-3.764h-14.019z",
    fill: "#fff"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m216.066 231.113h23.662v-3.764h-23.662z",
    fill: "#fff"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m202.552 231.113h7.306v-3.764h-7.306z",
    fill: "#fff"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m189.046 231.113h7.307v-3.764h-7.307z",
    fill: "#fff"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m261.892 231.113h3.767v-3.764h-3.767z",
    fill: "#fff"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m181.641 231.113h3.767v-3.764h-3.767z",
    fill: "#fff"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m244.228 293.564h14.019v-3.764h-14.019z",
    fill: "#fff"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m216.066 293.564h23.662v-3.764h-23.662z",
    fill: "#fff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m202.552 293.564h7.306v-3.764h-7.306z",
    fill: "#fff"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m189.046 293.564h7.307v-3.764h-7.307z",
    fill: "#fff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m261.892 293.564h3.767v-3.764h-3.767z",
    fill: "#fff"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m181.641 293.564h3.767v-3.764h-3.767z",
    fill: "#fff"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m156.271 117.721c.138.423.252.813.407 1.268 1.339 3.958 3.072 7.771 5.175 11.381 1.334 2.13 3.922 4.301 4.955 6.374.413.824.881 1.62 1.4 2.382-3.377 4.878-12.14 17.885-14.264 23.527 0 0-16.542-8.942-19.633-18.698-.009-.049 15.736-15.845 21.96-26.234z",
    fill: "#efab89"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m106.499 441.189s.513 18.698 3.442 21.259 40.17 3.675 43.376.26c3.206-3.414 1.326-9.162-6.672-11.381-8.568-2.374-12.775-.049-18.137-2.285-5.362-2.235-3.946-10.69-3.946-10.69z",
    fill: "#000d44"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m14.1412 440.555s-2.8722 18.219-.0407 20.885c2.8316 2.667 40.7643 5.642 44.0921 2.358 3.3279-3.284 1.6762-9.097-6.2244-11.625-8.4702-2.708-12.5711-.992-18.0388-2.976-4.2961-1.561-1.3995-10.243-1.3995-10.243z",
    fill: "#000d44"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m41.6673 335.692c-.6635-34.834 1.9407-69.654 7.7786-104.002 6.1919.227 12.4083.813 18.5921 3.593 11.3912 5.17 22.7824 10.129 34.222 15.105-9.2753 19.169-29.576 81.743-32.017 94.84-3.0431 16.259-37.1191 99.376-37.1191 99.376l-20.618-2.593c.3254-13.39 29.2347-101.84 29.1614-106.319z",
    fill: "#1b255e"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m68.5585 239.844c8.0389 2.707 22.6522 6.593 33.7015 10.568 7.689 19.413 30.407 65.24 31.586 85.962 1.302 22.861-6.615 109.482-6.615 109.482h-23.596s-2.188-97.629-5.4919-103.905c-10.8949-20.681-22.9371-37.079-29.7799-49.948-11.4807-21.592-15.3781-35.453-17.396-45.526-.895-4.463-4.7925-19.421 2.7827-24.104 6.257 1.699 8.0878 15.202 14.8086 17.471z",
    fill: "#1b255e"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m108.119 259.159s-18.2503-9.861-36.0694-14.714c-13.108-3.569-15.8744-4.715-28.1362-4.878-.2664-.002-.5274-.074-.7571-.209s-.4199-.328-.5517-.559-.2005-.493-.1993-.759.0723-.527.2062-.757c7.1927-12.122 41.4477-69.102 58.1195-83.239 18.714-15.885 36.029-12.682 36.029-12.682s9.04 12.706 19.145 17.072c0 0-6.273 38.209-14.19 53.574s-33.596 47.151-33.596 47.151z",
    fill: "#5468ff"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m181.047 141.988c-3.751 3.154-8.316 5.479-12.742 7.69-.355.239-.753.403-1.173.484-.419.081-.851.077-1.268-.012-.526-.25-.97-.645-1.278-1.138-2.803-3.849-5.113-8.033-6.875-12.455-1.344-2.97-2.222-6.128-2.604-9.365-.126-2.224-.06-4.454.195-6.666.346-5.166 1.009-10.305 1.986-15.39.878-4.13 1.977-9.8935 5.939-12.2348 1.497-.7976 3.1-1.3779 4.76-1.7235 5.305-1.3495 11.099-2.4389 16.094-.2357 4.41 1.9673 7.323 6.1703 10.236 10.016 1.798 2.373 3.792 5.024 3.491 7.991-.209 1.308-.647 2.568-1.294 3.723-1.741 3.569-3.564 7.114-5.02 10.813-1.798 4.56-3.068 9.406-5.818 13.462-1.305 1.885-2.862 3.581-4.629 5.041z",
    fill: "#f5b58f"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m177.947 108.795c.676.563 1.266 1.223 1.749 1.959 2.408 3.378 5.336 6.355 8.674 8.82 1.318.976 2.831 1.903 4.467 1.764 1.936-.162 3.401-1.755 5.167-2.577 2.611-1.219 5.752-.691 8.413-1.78 1.567-.691 2.855-1.891 3.654-3.405s1.062-3.253.748-4.936c-.635-2.951-3.027-5.317-3.515-8.292-.488-2.9756 1.098-6.5038-.269-9.3004-1.131-2.3332-3.881-3.3494-6.42-3.8615-2.538-.5122-5.28-.813-7.322-2.4389-2.043-1.6259-3.149-4.6583-5.574-5.9021-2.091-1.0731-4.589-.5528-6.941-.4634-5.166.2033-10.284-1.8129-15.459-1.2682-4.116.4581-7.892 2.4991-10.529 5.6907-1.342 1.6259-1.562 3.951-2.343 5.9184-.879 2.2147-1.992 4.3295-3.32 6.3085-1.489 2.2113-3.254 4.3656-3.726 6.9999-.201 2.045.06 4.109.765 6.04 1.27 4.318 2.828 8.547 4.662 12.658.569 1.276 1.342 2.691 2.709 3 .556.073 1.122.013 1.65-.173.529-.187 1.006-.495 1.393-.901.766-.706 1.371-1.567 1.777-2.526.405-.959.601-1.993.575-3.034-.082-2.439-1.359-4.919-.374-7.13.297-.55.721-1.023 1.235-1.38.515-.356 1.107-.587 1.727-.672.621-.086 1.253-.024 1.845.18s1.128.545 1.563.994c.907 1.3 1.279 2.897 1.042 4.463-.243 1.549-.35 3.116-.317 4.683.097.935.504 2 1.415 2.244.394.066.798.012 1.16-.157.362-.168.664-.442.866-.786.393-.693.668-1.445.814-2.228.759-2.829 2.15-5.45 4.068-7.666.506-.709 1.247-1.216 2.091-1.431.337-.038.678-.006 1.002.095.323.101.623.268.878.491z",
    fill: "#000d44"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m197.54 279.475c.913-.155 1.839-.228 2.766-.219 1.798.593 4.801-.269 6.062-.748 2.864-1.081 7.241-2.984 10.187-2.439 1.717.301 11.977 2.691 9.455 6.902-.334.561-1.628 1.447-1.953 1.309-1.05-.399-4.003-1.472-4.003-1.472.935.329 1.848.717 2.733 1.163.399.284 1.156.626 1.416 1.032.562.87-.293 2.748-1.188 3.057s-1.562-.585-2.31-.992h.048c.708.561 2.254.96 1.302 3.122-1.066 2.439-1.806.894-2.831.634-.381-.113-.752-.26-1.107-.439.727.352 1.436.74 2.124 1.163.96.813-1.164 3.707-3.068 3.463-1.163-.146-3.938-1.829-4.597-1.626-3.143.605-6.397.215-9.308-1.114-.96-.431-2.872-1.187-3.824-1.699-2.005-1.132-3.911-2.432-5.696-3.886 1.579-3.008 4.109-3.78 3.792-7.211z",
    fill: "#fff"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m196.693 290.678 9.089-13.617s-24.638-37.258-34.296-56.281c-9.658-19.024-15.671-53.322-25.98-58.647s-23.23-2.878-21.798 14.316 26.94 47.591 31.301 56.362c4.362 8.772 36.444 52.225 41.684 57.867z",
    fill: "#5468ff"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m516.021 480c46.933 0 84.979-2.013 84.979-4.496 0-2.482-38.046-4.495-84.979-4.495-46.932 0-84.978 2.013-84.978 4.495 0 2.483 38.046 4.496 84.978 4.496z",
    fill: "#5468ff",
    opacity: 0.15
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m549.895 450.295s.968 7.105 1.09 8.129 10.789-.626 10.789-.626l.862-8.455s-11.407-.048-12.741.952z",
    fill: "#f5b58f"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m550.847 457.562s-3.377 4.277-6.648 6.146c-3.271 1.87-8.405 2.602-10.333 4.537-1.392 1.39-5.078 7.389 8.494 7.276 13.572-.114 20.114.813 21.57-1.456 1.457-2.268-2.107-16.982-2.107-16.982s-3.295.967-10.976.479z",
    fill: "#000d44"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m476.063 450.295s.969 7.105 1.091 8.129 10.789-.626 10.789-.626l.862-8.455s-11.415-.048-12.742.952z",
    fill: "#f5b58f"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m477.039 457.563s-3.376 4.276-6.647 6.145c-3.271 1.87-15.297 3.399-17.225 5.325-1.392 1.391-3.711 7.008 15.386 6.504 13.572-.374 20.113.813 21.57-1.455 1.456-2.268-2.108-16.983-2.108-16.983-3.634.512-7.311.667-10.976.464z",
    fill: "#000d44"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m546.306 278.199c3.454 8.523 5.071 17.679 4.744 26.869-.716 14.633 2.831 30.64 4.28 45.924 1.627 17.072 8.234 57.37 8.47 66.484.236 9.113-1.025 38.209-1.025 38.209l-13.247.317s-11.122-70.516-14.003-77.711c-2.88-7.195-17.168-51.387-17.648-57.143s28.429-42.949 28.429-42.949z",
    fill: "#1b255e"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m491.4 276.435s-8.039 40.16-8.999 49.103c-.96 8.942-1.627 43.33-2.083 48.932-.455 5.601-3.197 73.231-5.76 81.548h14.768s15.142-49.184 15.142-72.435 10.04-43.469 16.525-58.818c6.485-15.348 21.318-18.08 25.305-46.558.008-.008-49.503-10.812-54.898-1.772z",
    fill: "#1b255e"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m536.623 168.718c4.792-8.13 6.167-18.877 7.379-28.202.57-4.39 1.571-10.641-1.513-13.381-3.312-2.943-3.629-7.479-7.429-9.756-3.8-2.276-8.95-2.439-12.546.139",
    fill: "#000d44"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m523.345 197.383c-1.741.132-3.491-.087-5.146-.644-1.654-.557-3.18-1.441-4.486-2.599-1.305-1.158-2.364-2.567-3.114-4.143-.75-1.575-1.174-3.285-1.249-5.028-.293-7.065-.553-14.211-.553-14.211s-10.724-.975-11.53-11.568c-.805-10.593-.529-35.071-.529-35.071 5.87-2.976 12.428-4.333 18.998-3.93s12.912 2.551 18.373 6.222l-.553 37.315.057 20.072c-.073 6.723-3.555 13.048-10.268 13.585z",
    fill: "#f5b58f"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m507.779 146.215c1.823-2.268 4.801-3.179 7.25-1.626 1.203.83 2.072 2.059 2.452 3.469s.246 2.909-.377 4.23c-.546.981-1.288 1.838-2.182 2.518-.893.68-1.918 1.168-3.009 1.433-.978.213-1.843.778-2.43 1.588s-.855 1.807-.752 2.802c.31 2.658 4.744 3.65 6.754 5.845 3.116 3.414 9.951 4.878 14.548 5.374s3.979.569 6.591-3.155c1.76-2.521 2.656-5.544 2.554-8.617l.415-23.454c.168-2.817-.021-5.644-.561-8.414-.558-2.793-2.15-5.273-4.459-6.943-2.587-1.691-5.858-1.821-8.796-2.764-3.677-1.179-6.81-3.601-10.252-5.349-3.441-1.748-7.664-2.788-11.106-1.041-2.441 1.252-4.125 3.724-6.509 5.106-3.426 1.959-8.096 1.528-9.764 6.577-.558 1.757-.533 3.648.073 5.39 2.343 6.853 10.854 9.592 16.973 6.609.122 1.162-1.017 3.748.22 7.414.39 1.171.537 2.959 2.376 2.984",
    fill: "#000d44"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m509.691 152.824c-.041 0-.041.204.146.456.146.175.327.318.532.419.205.1.428.157.656.166 1.188.106 2.693-1.171 2.742-2.935.022-.409-.039-.819-.179-1.204s-.356-.739-.634-1.04c-.434-.474-1.001-.806-1.628-.951-1.09-.227-1.725.179-1.676.252s.651-.049 1.53.269c.553.179 1.033.534 1.365 1.011s.498 1.05.474 1.631c.01.575-.184 1.135-.547 1.581-.364.447-.873.75-1.439.858-.87.056-1.261-.578-1.342-.513z",
    fill: "#efab89"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m506.168 180.66 2.758-5.674 24.703-.903 3.035 7.366h-30.105",
    fill: "#5468ff"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m506.168 180.66 2.758-5.674 24.703-.903 3.035 7.366h-30.105",
    fill: "#000d44",
    opacity: 0.2
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m442.508 231.877h17.901l15.98 2.439-9.845 22.51-27.771-20.088 1.034-1.683c.728-1.194 1.64-2.266 2.701-3.178z",
    fill: "#f5b58f"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m423.785 231.885c.171-.862-6.339-34.673-8.137-43.965-.055-.285-.046-.579.025-.86.072-.282.205-.543.39-.767.186-.224.418-.404.681-.528.263-.123.55-.187.841-.186h48.005c.443 0 .872.15 1.219.424.347.275.591.658.694 1.088l9.829 41.396 24.222 1.804-.814 1.626z",
    fill: "#5468ff"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m423.785 231.885c.171-.862-6.339-34.673-8.137-43.965-.055-.285-.046-.579.025-.86.072-.282.205-.543.39-.767.186-.224.418-.404.681-.528.263-.123.55-.187.841-.186h48.005c.443 0 .872.15 1.219.424.347.275.591.658.694 1.088l9.829 41.396 24.222 1.804-.814 1.626z",
    fill: "#000d44",
    opacity: 0.2
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m425.892 228.885-7.77-40.998 47.184.285 10.358 40.77z",
    fill: "#fff"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m418.163 187.92 7.754 40.941 49.715.056-10.35-40.713z",
    fill: "#5468ff",
    opacity: 0.05
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m429.188 218.812c.203.048.411.07.619.065l1.765.057 6.51.098c5.492.057 13.075.089 21.448.089h7.266l-.098-.366-4.198-16.259-1.286-4.731c-.132-.577-.309-1.142-.529-1.691.066.587.178 1.169.334 1.739l1.114 4.781 3.996 16.259.284-.366h-6.883c-8.373 0-15.964 0-21.448.089l-6.51.098-1.765.057c-.209 0-.417.027-.619.081z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m463.362 217.26-.879-3.951h-6.07l.773 3.951z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m455.111 217.26-1.839-7.781h-6.07l1.725 7.781z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m446.853 217.26-.879-3.951h-6.078l.782 3.951z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m438.594 217.259-3.474-15.121h-6.07l3.368 15.121z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m458.602 221.682c0 .171 1.106.293 2.441.276 1.334-.016 2.441-.162 2.441-.325 0-.162-1.091-.292-2.441-.276-1.351.016-2.45.122-2.441.325z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m450.595 221.666c0 .171 1.106.293 2.441.276 1.334-.016 2.441-.162 2.441-.325 0-.162-1.091-.293-2.441-.276-1.351.016-2.449.138-2.441.325z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m442.63 221.65c0 .17 1.107.292 2.441.276s2.441-.163 2.441-.325c0-.163-1.09-.293-2.441-.277-1.351.017-2.482.155-2.441.326z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m434.591 221.641c0 .171 1.106.293 2.441.277 1.334-.016 2.441-.163 2.441-.325 0-.163-1.09-.293-2.441-.277-1.351.017-2.449.163-2.441.325z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m453.158 194.611c3.752 0 6.794-.135 6.794-.301s-3.042-.301-6.794-.301-6.794.135-6.794.301 3.042.301 6.794.301z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m456.519 192.928c1.663 0 3.011-.135 3.011-.301s-1.348-.301-3.011-.301c-1.662 0-3.01.135-3.01.301s1.348.301 3.01.301z",
    fill: "#5468ff",
    opacity: 0.25
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m565.256 252.201-23.075-9.162 5.15-19.097 18.804 6.382z",
    fill: "#5468ff"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m467.479 257.355c-5.753-2.854-7.226-9.707-4.418-15.446l23.905-51.054c.556-1.267 1.391-2.392 2.441-3.293 2.682-2.383 5.813-4.208 9.209-5.369s6.99-1.636 10.571-1.395l24.93-.65s19.585 0 26.932 15.446c.537 1.13 11.92 23.69 19.431 38.559.821 1.62 1.289 3.396 1.374 5.21.084 1.814-.216 3.625-.883 5.315-.666 1.689-1.683 3.219-2.984 4.487-1.3 1.269-2.855 2.248-4.562 2.873-3.059 1.123-6.431 1.044-9.435-.221-3.004-1.264-5.415-3.62-6.749-6.592l-8.136-18.161-1.286 6.504c-2.31 11.722-3.515 30.079-.431 41.794.611 2.231.931 4.532.952 6.845v.276l-59.015-2.471 4.882-33.388 1.506-20.454-12.539 25.835c-.674 1.39-1.617 2.632-2.774 3.656-1.158 1.023-2.507 1.806-3.97 2.305-1.462.499-3.009.704-4.551.601-1.542-.102-3.049-.508-4.433-1.196z",
    fill: "#5468ff"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m503.654 212.301c-1.457 11.747-.814 10.853-3.255 22.437-1.204 5.691-2.669 11.642-6.607 15.942l1.945-24.535z",
    fill: "#5468ff"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m558.234 245.477c.56.897 1.212 1.734 1.945 2.496-.446-.956-.977-1.87-1.587-2.731-1.033-1.626-2.441-3.927-3.971-6.504-1.529-2.577-2.823-7.317-3.775-8.943-.461-.946-1.005-1.849-1.627-2.699.318 1.009.741 1.981 1.261 2.903.862 1.748 2.115 6.503 3.637 9.089",
    fill: "#5468ff"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m493.524 187.887c0 .098 1.042.48 2.58 1.439 2.008 1.232 3.72 2.891 5.015 4.857 1.295 1.967 2.141 4.195 2.479 6.525.268 1.796.187 2.934.292 2.934.242-.978.286-1.995.131-2.991-.233-2.427-1.055-4.76-2.395-6.798-1.34-2.037-3.157-3.717-5.294-4.893-.856-.54-1.81-.905-2.808-1.073z",
    fill: "#5468ff"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m550.188 226.808c3.266-14.637 5.782-26.532 5.62-26.568s-2.942 11.8-6.208 26.437c-3.267 14.636-5.783 26.531-5.621 26.567.163.036 2.942-11.8 6.209-26.436z",
    fill: "#5468ff"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m438.748 236.73-11.277-4.845h15.02l-3.279 4.243",
    fill: "#f5b58f"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m482.686 252.932c.362-.494.68-1.019.952-1.569.577-1.024 1.383-2.528 2.359-4.39 1.961-3.723 4.557-8.942 7.404-14.674 2.848-5.731 5.46-10.942 7.397-14.674l2.294-4.422c.318-.518.59-1.062.814-1.626-.375.482-.707.997-.993 1.536-.61 1.008-1.448 2.488-2.441 4.333-2.034 3.683-4.711 8.854-7.559 14.634l-7.249 14.755-2.189 4.471c-.309.519-.573 1.063-.789 1.626z",
    fill: "#5468ff"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m558.234 245.477c.56.897 1.212 1.734 1.945 2.496-.446-.956-.977-1.87-1.587-2.731-1.033-1.626-2.441-3.927-3.971-6.504-1.529-2.577-2.823-7.317-3.775-8.943-.461-.946-1.005-1.849-1.627-2.699.318 1.009.741 1.981 1.261 2.903.862 1.748 2.115 6.503 3.637 9.089",
    fill: "#000d44",
    opacity: 0.1
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m493.524 187.887c0 .098 1.042.48 2.58 1.439 2.008 1.232 3.72 2.891 5.015 4.857 1.295 1.967 2.141 4.195 2.479 6.525.268 1.796.187 2.934.292 2.934.242-.978.286-1.995.131-2.991-.233-2.427-1.055-4.76-2.395-6.798-1.34-2.037-3.157-3.717-5.294-4.893-.856-.54-1.81-.905-2.808-1.073z",
    fill: "#000d44",
    opacity: 0.1
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m550.188 226.808c3.266-14.637 5.782-26.532 5.62-26.568s-2.942 11.8-6.208 26.437c-3.267 14.636-5.783 26.531-5.621 26.567.163.036 2.942-11.8 6.209-26.436z",
    fill: "#000d44",
    opacity: 0.1
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m482.686 252.932c.362-.494.68-1.019.952-1.569.577-1.024 1.383-2.528 2.359-4.39 1.961-3.723 4.557-8.942 7.404-14.674 2.848-5.731 5.46-10.942 7.397-14.674l2.294-4.422c.318-.518.59-1.062.814-1.626-.375.482-.707.997-.993 1.536-.61 1.008-1.448 2.488-2.441 4.333-2.034 3.683-4.711 8.854-7.559 14.634l-7.249 14.755-2.189 4.471c-.309.519-.573 1.063-.789 1.626z",
    fill: "#000d44",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg);
export default __webpack_public_path__ + "static/media/about-img.5d30e7197898b2deb784ed53baca2b29.svg";
export { ForwardRef as ReactComponent };